import React, { JSX } from 'react'
import { AnalyticsMetafield, ReferralTotals } from 'types/api'
import { cleanVariables, graphqlRequest } from 'lib/helpers'
import { RefreshingBlock } from './Loading'
import getReferralPlatforms from '../graphql/getReferralPlatformTotals.graphql'
import { useQuery } from '@tanstack/react-query'
import { Leaderboard } from './Leaderboard'

export interface ReferralLeaderboardProps {
  filters: {
    productOption?: AnalyticsMetafield[]
    bundleOption?: AnalyticsMetafield[]
    range: {
      startDate: Date
      endDate: Date
    }
    project?: AnalyticsMetafield
  }
  token?: string
  client: AnalyticsMetafield | null
}

export const ReferralPlatformLeaderboard = ({ token, client, filters }: ReferralLeaderboardProps): JSX.Element => {
  const {
    data,
    isFetching
  } = useQuery({
    queryKey: ['dashboard', 'referralPlatforms', filters, client?.id],

    queryFn: async () => {
      if (token == null) return

      const cleanVar = cleanVariables({
        clientId: client?.id,
        projectId: filters.project?.id,
        productIds: filters?.productOption?.map(p => p.id),
        startDate: filters.range.startDate,
        endDate: filters.range.endDate
      })
      const { referralPlatforms } = await graphqlRequest<{ referralPlatforms: ReferralTotals[] }>(
        getReferralPlatforms, cleanVar, token
      )

      return referralPlatforms
    },

    enabled: token != null && client != null,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false
  })

  return (
    <div data-testid='referring-platform-leaderboard' className='relative shadow-sm dark:shadow-[0_12px_32px_-14px_rgba(0,0,0,0.7)] dark:ring-1 dark:ring-white/3 rounded-none md:rounded-2xl overflow-hidden p-4 min-h-[280px] flex flex-col'>
      {isFetching && RefreshingBlock}
      <Leaderboard
        noDataMessage='No referral platform data for specified filters'
        hoverData={false}
        idField='referralPlatform'
        data={data ?? []}
        defaultSortKey='sales'
        columns={['referralPlatform', 'sales']}
        title='Top referral platforms by sales'
        limit={10}
      />

    </div>
  )
}
